module.exports = __webpack_public_path__ + "static/media/SALVA.fdcc20d4.png";